import { useState } from "react";
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS, PAGE_SIZE_STORAGE_KEY, } from "../utils/constants";
var readStoredPageSize = function () {
    var stored = Number(localStorage.getItem(PAGE_SIZE_STORAGE_KEY));
    return PAGE_SIZE_OPTIONS.includes(stored) ? stored : DEFAULT_PAGE_SIZE;
};
export var usePageSize = function () {
    var _a = useState(readStoredPageSize), pageSize = _a[0], setPageSizeState = _a[1];
    var createPageSizeHandler = function (onReset) { return function (size) {
        setPageSizeState(size);
        localStorage.setItem(PAGE_SIZE_STORAGE_KEY, String(size));
        onReset === null || onReset === void 0 ? void 0 : onReset(0);
    }; };
    return { pageSize: pageSize, createPageSizeHandler: createPageSizeHandler };
};
